import React, { createContext } from "react";

export const SolutionFormContext = createContext();

function SolutionFormProvider({
  children,
  formMethods,
  disableRestrictedFields,
  copyPasteRestricted,
}) {
  return (
    <SolutionFormContext.Provider
      value={{
        formMethods: formMethods,
        disableRestrictedFields: disableRestrictedFields,
        copyPasteRestricted: copyPasteRestricted,
      }}
    >
      {children}
    </SolutionFormContext.Provider>
  );
}

export default SolutionFormProvider;
